import { Semantic, semantic } from './generated/tokens.generated';

/**
 * `theme.space` is the Figma 4/8 spacing scale, sourced from the generated semantic ramp —
 * the CI drift gate keeps it aligned with the "Kickfin - Design System" file. Do not
 * hand-edit values; change the Figma exports and run `yarn tokens:build`.
 *
 * Semantic rather than primitive because the spacing page is explicit: components consume
 * semantic, never primitives — the primitive tier exists only for defining the ramp. The ramp
 * has covered the whole scale 1:1 since the three half-steps were retired (2026-09-08).
 *
 * Note `theme.font.size` stays on the primitives: the semantic tier has no type group at all
 * (`bg`, `text`, `border`, `space` only), so the two scales reading different tiers is the
 * shape of the Figma file, not an inconsistency here.
 *
 * Shape is derived from the generated type, not hand-listed, so a name added in Figma flows
 * through as a type change rather than silent drift.
 * (Type alias rather than an interface because it's mapped from the generated type.)
 */
export type ISpace = Semantic['space'];

export const Space: ISpace = semantic.space;
